import eradicationAnimal from "../Assets/projects/feralAnimal.png";
import movieAndroid from "../Assets/projects/movieAndroid.png";
import wechat from "../Assets/projects/wechat.jpeg";
import movieApple from "../Assets/projects/movieApple.jpg";
import chris from "../Assets/projects/chris.gif";
import portfolio from "../Assets/projects/portfolio.png";
import studyOnline from "../Assets/projects/studyOnline.gif";
import e2e from "../Assets/projects/E2E.gif"; 
export const projects = [
    {
        name: "Merry Christmas",
        description:
          "Developed a Christmas card with various special animation effects using SVG, Canvas and GSAP",
        image: chris,
        source_code_link: "https://codepen.io/chengguang-li/pen/zYLvYjW",
        tags: [
          {
            name: "Javascript",
            color: "#ccffcc",
          },
          {
            name: "SVG",
            color: "#99ccff",
          },
          {
            name: "GSAP",
            color: "#ffb3ff",
          },
          {
            name: "Canvas",
            color: "#d9b3ff",
          },
          {
            name: "CSS",
            color: "#ffccb3",
          },
        ],
      },
  {
    name: "Personal Web",
    description: "Developed a personal website as a self-introduction.",
    image: portfolio,
    source_code_link: "https://github.com/ChengGuang-Li/myPortfolio",
    tags: [
      {
        name: "React.js",
        color: "#ccffcc",
      },
      {
        name: "Html",
        color: "#99ccff",
      },
      {
        name: "CSS",
        color: "#ffb3ff",
      },
      {
        name: "Vercel",
        color: "#ffccb3",
      },
      {
        name: "Router",
        color: "#d9b3ff",
      },
      {
        name: "Lazy Loading",
        color: "#ccffcc",
      },
      {
        name: "Particles Animation",
        color: "#99ccff",
      },
    ],
  },
  {
    name:  "Online Study Platform",
    description: "Developed an online study platform that supports course release, authentication and authorization, course approval, online payment, watching course videos, and etc.",
    image: studyOnline,
    source_code_link: "https://github.com/ChengGuang-Li/",
    tags: [
      {
        name: "Java",
        color: "#ccffcc",
      },
      {
        name: "Spring Cloud",
        color: "#99ccff",
      },
      {
        name: "Microservices",
        color:  "#ffb3ff",
      },
      {
        name: "MySQL",
        color: "#ffccb3",
      },
      {
        name: "Mybatis",
        color: "#99ccff",
      },

      {
        name: "Redis",
        color: "#d9b3ff",
      },
      {
        name: "Elasticsearch",
        color: "#ccffcc",
      },
      {
        name: "XXL-Job",
        color: "#ffccb3",
      },
      {
        name: "RabbitMQ",
        color: "#99ccff",
      },
      {
        name: "MinIO",
        color: "#ffb3ff",
      },
      {
        name: "Nacos",
        color: "#ffccb3",
      },
      {
        name: "Feign",
        color: "#d9b3ff",
      },
      {
        name: "FreeMarker",
        color: "#ccffcc",
      },
      {
        name: "JWT",
        color: "#99ccff",
      },
      {
        name: "OAuth2",
        color: "#99ccff",
      },
      {
        name: "Nginx",
        color: "#ccffcc",
      },
      { 
        name: "Javascript",
        color: "#ccffcc",
      },
      {
        name: "Html",
        color: "#99ccff",
      },
      {
        name: "CSS",
        color: "#ffb3ff",
      },
      {
        name: "React.js",
        color: "#ffccb3",
      },
      {
        name: "react-router-dom",
        color: "#d9b3ff",
      },
      {
        name: "Mock.js",
        color: "#ccffcc",
      },
      {
        name: "MobX",
        color: "#99ccff",
      },
      {
        name: "Webpack",
        color: "#99ccff",
      },
      { 
        name: "NPM",
        color: "#ffb3ff",
      },
      {
        name: "Material UI",
        color: "#ffccb3",
      },
      {
        name: "SVG",
        color: "#d9b3ff",
      }
    ],
  },
  {
    name: "Front-end Automated Testing Project",
    description:
      "The animation shown above depicts a small portion of the whole project, which is the  supplementary materials. Automated testing only requires 50 seconds, whereas manual testing takes between 5 to 10 minutes depending on the tester's familiarity with the process and data.  Therefore, the value of automated testing projects are as follows: guarantee test quality, reduce repetitive and tedious operations, reduce communication costs, reduce management costs, and improve work efficiency.",
    image: e2e,
    source_code_link: "https://github.com/ChengGuang-Li/",
    tags: [
      {
        name: "Javascript",
        color: "#ccffcc",
      },
      {
        name: "Jquery",
        color: "#99ccff",
      },
      {
        name: "Cypress",
        color: "#ffb3ff",
      },
      {
        name: "DataTransfer",
        color: "#d9b3ff",
      },
      {
        name: "Node.js",
        color: "#ffccb3",
      },
      {
        name: "PAAS",
        color: "#ccffcc",
      },
    ],
  },

  {
    name: "Wechat Information Push",
    description:
      "Developed the WeChat message push service to realize the function of pushing weather information, precautions, anniversaries, and extra to me and my girlfriend regularly every day so as to shorten the distance of our long-distance relationship. The service has been running stably for 4 months and is still iterating new functions.",
    image: wechat,
    source_code_link: "https://github.com/ChengGuang-Li/wechat-love-push",
    tags: [
      {
        name: "Node.js",
        color: "#ccffcc",
      },
      {
        name: "Github Actions",
        color: "#99ccff",
      },
      {
        name: "Wechat",
        color: "#ffb3ff",
      },
    ],
  },
  {
    name: "Eradication Unwanted Animals in VIC",
    description:
      "In order to help Victorian farmers protect their farms from harmful animals, another classmate and I developed a web application based on the Next.js framework to meet this requirement.",
    image: eradicationAnimal,
    source_code_link: "https://github.com/ChengGuang-Li/IE-iteration3Web",
    tags: [
      {
        name: "Next.js",
        color: "#ccffcc",
      },
      {
        name: "Material UI",
        color: "#99ccff",
      },
      {
        name: "PostgreSQL",
        color: "#ffb3ff",
      },
      {
        name: "Spring Boot",
        color: "#d9b3ff",
      },
      {
        name: "Heroku Cloud",
        color: "#ffccb3",
      },
      {
        name: "R",
        color: "#ccffcc",
      },
      {
        name: "Linux",
        color: "#99ccff",
      },
      {
        name: "Visualization",
        color: "#ffb3ff",
      },
    ],
  },
  {
    name: "Movie Memoir",
    description:
      "Developed a native Android App with functions such as searching and viewing movie details.",
    image: movieAndroid,
    source_code_link: "https://github.com/ChengGuang-Li/MovieMemoir",
    tags: [
      {
        name: "MySQL",
        color: "#ccffcc",
      },
      {
        name: "Java",
        color: "#99ccff",
      },
      {
        name: "Android Studio",
        color: "#ffb3ff",
      },
      {
        name: "Gradle",
        color: "#ffccb3",
      },
      {
        name: "OkHttp",
        color: "#d9b3ff",
      },
      {
        name: "Glide",
        color: "#ccffcc",
      },
    ],
  },
  {
    name: "Movie Lover",
    description:
      "Developed a native iOS App with functions such as searching and viewing movie details",
    image: movieApple,
    source_code_link: "https://github.com/ChengGuang-Li/FIT5140FinalApp.git",
    tags: [
      {
        name: "Swift",
        color: "#ccffcc",
      },
      {
        name: "Xcode",
        color: "#99ccff",
      },
      {
        name: "CocoaPods",
        color: "#ffb3ff",
      },
      {
        name: "SnapKit",
        color: "#ffccb3",
      },
      {
        name: "SwiftyJSON",
        color: "#d9b3ff",
      },
      {
        name: "SnapKit",
        color: "#ccffcc",
      },
      {
        name: "Firebase",
        color: "#99ccff",
      },
    ],
  }
];
